import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { TelaDeCamadas } from '@/components/gestor/camadas/TelaDeCamadas'

/*
 * `/gestor/camadas`: a lista do catálogo e a fila de camadas que esperam
 * revisão. A guarda e a recusa por cargo moram na casca (`/gestor`), então esta
 * tela só monta para quem tem a área Camadas.
 */
function Tela() {
  const { incluir, arquivo } = Route.useSearch()
  const navigate = useNavigate({ from: '/gestor/camadas' })
  return (
    <TelaDeCamadas
      aoFecharFormulario={() => {
        // Sem isto, recarregar a página depois de fechar o quadro o reabriria.
        if (incluir !== undefined || arquivo !== undefined) {
          void navigate({ search: {}, replace: true })
        }
      }}
      abrirFormulario={incluir === true || arquivo !== undefined}
      arquivoInicial={arquivo}
    />
  )
}

/*
 * `?incluir=true` abre o quadro do formulário já na carga: o endereço leva
 * direto à camada nova, para link e para captura de tela sem clique.
 * `?arquivo=<id>` abre o quadro retomando um arquivo que o servidor já recebeu:
 * mostra a análise dele (andamento, aceito ou recusado), sem escolher de novo.
 */
export const Route = createFileRoute('/gestor/camadas')({
  validateSearch: (busca: Record<string, unknown>): { incluir?: true; arquivo?: number } => {
    const id = Number(busca.arquivo)
    return {
      ...(busca.incluir === true || busca.incluir === 'true' ? { incluir: true as const } : {}),
      ...(Number.isInteger(id) && id > 0 ? { arquivo: id } : {}),
    }
  },
  component: Tela,
})
